<template>
  <BaseLayout title="Home">
    <!-- Main Content (Center) -->
    <div class="container my-4">
      <h2 class="display-4 text-center">Welcome to PA036</h2>
      <div v-html="markdownContent"></div>
    </div>

    <!-- Right Sidebar Slot -->
    <template v-slot:right-sidebar>
    </template>
  </BaseLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseLayout from '@/components/BaseLayout.vue';
import { marked } from 'marked';
import helpMarkdown from 'raw-loader!@/assets/home.md';

export default {
  name: 'HomeView',
  components: {
    BaseLayout,
  },
  computed: {
    ...mapGetters(['isTeacher']),
    markdownContent() {
      // Use imported markdown content
      return marked.parse(helpMarkdown);
    }
  }
};
</script>
